export const customCheckboxStylesForMobile = `
border-bottom: none;
&:not(:last-child){
  border-bottom: 1px solid #dcdfe4;
}
&:last-child{
  margin-bottom: 6px;
}  
&:first-child {
  border-top: none;
}`;
